// extracted by mini-css-extract-plugin
module.exports = {"section":"section-module--section--Rms0L"};